import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ModelFinetuneDeploymentSettings} from '~components/models/finetune/deployment-settings/ModelFinetuneDeploymentSettings';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/finetune/deployment-settings')({
  component: ModelFinetuneDeploymentSettingsPage,
});

function ModelFinetuneDeploymentSettingsPage() {
  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout showBackButton customContentAndFooter>
        <ModelFinetuneDeploymentSettings />
      </BaseLayout>
    </ModelProvider>
  );
}
